<template>
  <b-modal
    id="modalHistoricoConfiguracaoCaixaPostal"
    ref="modalHistoricoConfiguracaoCaixaPostal"
    button-size="sm"
    no-close-on-backdrop
    ok-only
    ok-title="Ok"
    modal-class="modal-historico-config-caixa-postal"
    scrollable
    @hidden="historico = []"
  >
    <div slot="modal-title">
      <h5 class="mb-0">
        Histórico de Alterações
      </h5>
      <fieldset class="font-weight-bold text-muted small">
        Histórico de alterações
      </fieldset>
    </div>

    <b-table
      :items="historicoOrdenado"
      :fields="colunas"
      responsive
      hover
      show-empty
      empty-text="Nenhum registro de alteração encontrado"
    >
      <template #cell(data)="{ value }">
        {{ formatarData(value) }}
      </template>
      <template #cell(campo)="{ value }">
        <b-badge
          variant="light-success"
          style="font-size: 0.75rem; font-weight: 500; padding: 0.4em 0.8em; border-radius: 4px;"
        >
          {{ value }}
        </b-badge>
      </template>
      <template #cell(de)="{ value }">
        {{ formatarValor(value) }}
      </template>
      <template #cell(para)="{ value }">
        {{ formatarValor(value) }}
      </template>
    </b-table>
  </b-modal>
</template>

<style lang="scss">
.modal-historico-config-caixa-postal .modal-dialog {
  max-width: 900px;
}
</style>

<script>
import api from '../../services/api'

export default {
  name: 'HistoricoConfiguracaoCaixaPostal',
  data() {
    return {
      historico: [],
      colunas: [
        { key: 'data', label: 'Data', sortable: true },
        { key: 'usuario', label: 'Usuário', sortable: true },
        { key: 'campo', label: 'Campo', sortable: true },
        { key: 'de', label: 'De', sortable: true },
        { key: 'para', label: 'Para', sortable: true },
      ],
    }
  },
  computed: {
    historicoOrdenado() {
      return [...this.historico].sort((a, b) => new Date(b.data) - new Date(a.data))
    },
  },
  methods: {
    show() {
      this.carregar()
      this.$refs.modalHistoricoConfiguracaoCaixaPostal.show()
    },
    carregar() {
      api.getHistoricoConfiguracao()
        .then(response => {
          this.historico = response.data || []
        })
        .catch(() => {
          this.historico = []
        })
    },
    formatarData(dataString) {
      if (!dataString) return ''
      try {
        const d = new Date(dataString)
        const pad = v => String(v).padStart(2, '0')
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
      } catch {
        return dataString
      }
    },
    formatarValor(valor) {
      if (valor === null || valor === undefined || valor === '') return 'Em branco'
      return valor
    },
  },
}
</script>
